import { render, staticRenderFns } from "./centerB-Right-temp3.vue?vue&type=template&id=1de08ac8&scoped=true"
import script from "./centerB-Right-temp3.vue?vue&type=script&lang=js"
export * from "./centerB-Right-temp3.vue?vue&type=script&lang=js"
import style0 from "./centerB-Right-temp3.vue?vue&type=style&index=0&id=1de08ac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de08ac8",
  null
  
)

export default component.exports